import { HttpParams } from '@angular/common/http';
import { CustomFilterService } from 'path-shared/services/datasource/custom-filter-service';

const defaultSortParam = 'id';
const defaultSortDirection = 'asc';

export class TextoAvisoFilterService extends CustomFilterService {

    public createFilterParams(filter: any, start: number, pageSize: number, sortField: string, sortDir: string): HttpParams {
        return new HttpParams()
        .append('titulo', filter.titulo ? filter.titulo : '')
        .append('fechaInicio', filter.fechaInicio ? this.formatDateToDecimal(filter.fechaInicio) : '')
        .append('fechaFin', filter.fechaFin ? this.formatDateToDecimal(filter.fechaFin) : '')
        .append('permiteLogIn', filter.permiteLogIn ? filter.permiteLogIn.toString() : '')
        .append('idioma', filter.idioma ? filter.idioma : '')
        .append('start', start.toString())
        .append('size', pageSize.toString())
        .append('sortparam', sortField === undefined ? defaultSortParam : sortField)
        .append('sortdir', sortDir === '' ? defaultSortDirection : sortDir);
    }

    formatDateToLocal(fecha: Date): string {
        fecha = new Date(fecha);
        const dateString =
            fecha.getFullYear() + '-' +
            ('0' + (fecha.getMonth() + 1)).slice(-2) + '-' +
            ('0' + fecha.getDate()).slice(-2);
        return dateString;
    }

    formatDateToDecimal(date: Date): string {
        const dateString = this.formatDateToLocal(date);
        const formatedDate = dateString.replace('-', '').replace('-', '').replace('/', '').replace(' ', '');
        return formatedDate;
    }
}
